'use strict';

import keyframes from "./keyframes.js";
import { create } from "./stylesheet.js";
export const css = {
  create,
  keyframes
};
//# sourceMappingURL=index.js.map